import { Component, OnInit, HostBinding, AfterViewInit, ViewChild, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { AccountService } from '../../services/account.service';
import { ActivatedRoute, RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ScrollToTop } from '../../utils/functions';
import { DOCUMENT } from '@angular/common';
import { IdleLogoutService } from '../../services/idle-logout.service';
@Component({
  selector: 'app-super-admin-dashboard',
  templateUrl: './super-admin-dashboard.component.html',
  styleUrls: ['./super-admin-dashboard.component.scss'],
})
export class SuperAdminDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.portal-admin') true;
  @ViewChild('outlet') pageOutlet: RouterOutlet;
  toggle: any;
  hide: boolean;
  isCollapsedMenu;
  toggleMenu = new EventEmitter();
  constructor(
    private accountService: AccountService,
    private route: ActivatedRoute,
    // @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private idleLogoutService: IdleLogoutService
  ) {
    this.accountService.emitChange.subscribe((status) => {
      this.toggleMenu.emit(status);
      this.isCollapsedMenu = status;
    });
    this.accountService.emitChange.subscribe((status) => (this.toggle = status));
    router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      this.hide = e.url.indexOf('chat') >= 0 ? true : false;
    });
  }

  ngOnInit() {
    // Initialize idle logout for super admin module
    this.idleLogoutService.initializeIdleLogout('super-admin');
  }
  ngAfterViewInit() {
    this.route.url.subscribe((url) => {
      ScrollToTop();
    });
    this.route.params.subscribe((url) => {
      ScrollToTop();
    });
    if (this.pageOutlet) {
      this.pageOutlet.activatedRoute.url.subscribe((e) => {
        ScrollToTop();
      });
    }
  }
  sidebarToggle(status) {
    // this.document.body.classList.toggle('sidebar-collapse-in');
    this.toggleMenu.emit(status);
    this.accountService.emit(status);
  }
  toggleTopMenu(e) {
    this.toggle = e;
  }

  ngOnDestroy() {
    // Disable idle logout when component is destroyed
    this.idleLogoutService.disableIdleLogout();
  }
}
